import { action, observable } from "mobx";
import { ILocalization } from "../models/localization";
import { LookupValue, RegistrationRegion } from "../models/lookup";
import { LookupType } from "../models/enums";
import SeekerStore from "./seekerStore";
import Fetcher from "../utils/fetcher";
import { copyArray, sort } from "../utils/data";

export default class Localization {
  private _store: SeekerStore;
  @observable selLanguage: string;
  @observable fields: ILocalization;
  @observable lookups: Array<LookupValue>;
  @observable regions:Array<RegistrationRegion>

  // Keys used to store session data
  private readonly langKey: string = "skillsmart-lang";

  constructor(store: SeekerStore) {
    this._store = store;
    this.initLocalization();
    this.initLookups();
    this.initRegions();
  }
  @action clear(): void {
  }
  initLocalization(): void {
    this._store.addBusy();
    if (!this.fields || this.language !== this.fields.language) {
      Fetcher.get(`api/lookups/fields/${this._store.appName}/${this.language}`, action((f: string): void => {
        this.fields = JSON.parse(f);
        this.fields.language = this.language;
        this._store.clearBusy();
      }));
    }
  }
  initRegions(): void {
    Fetcher.get("api/domains/domain/regions", action((regions:Array<RegistrationRegion>): void => {
      this.regions = new Array<RegistrationRegion>();
      copyArray(regions, this.regions, (rr: RegistrationRegion) => { return new RegistrationRegion(rr); });
    }));
  }
  @action initLookups(): void {
    this._store.addBusy();
    this.lookups = new Array<LookupValue>();
    Fetcher.postWithData("api/lookups/valuelist", [1,3,6,7,9,10,11,12,14,15,16,17,18,19,20,21,23,24,25,26,27,29], action((lvs:Array<LookupValue>): void => {
      copyArray(lvs, this.lookups, (lv: LookupValue) => { return new LookupValue(lv) });
      this._store.clearBusy();
    }));
  }
  get language(): string {
    const lang: string = localStorage.getItem(this.langKey) || "en";
    document.cookie = `${this.langKey}=${lang};path=/`;
    return lang;
  }
  set language(lang: string) {
    localStorage.setItem(this.langKey, lang);
    document.cookie = `${this.langKey} = ${lang};path=/`;
    this._store.languageCallbacks.map((cb: () => void): void => cb());
    this.initLocalization();
    this.initLookups();
    this.initRegions();
    this._store.remapHelpTopicsForLanguage();
    this._store.opportunityStore.languageReset();
  }
  getLookup(lt: LookupType): Array<LookupValue> {
    return sort(this.lookups.filter((lv: LookupValue): boolean => { return lv.type === lt }), "order");
  }
}


// WEBPACK FOOTER //
// ./src/stores/localization.ts